import { Sheets } from "common/sheets";
export class Background {
    constructor(pixiContext, sheets) {
        this.sprite = Sheets.animation(pixiContext, sheets, imageName);
    }
}
export const imageName = "배경";
//# sourceMappingURL=background.js.map